import React, { FC } from "react";
import { Chip, ChipProps } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface Color {
  backgroundColor: string;
  color: string;
  deleteIconColor?: string;
  deleteIconHoverColor?: string;
}

const StyledChip: FC<ChipProps & { active?: boolean }> = ({
  active = true,
  ...props
}) => {
  const color: Color = active
    ? {
        backgroundColor: "#F1F6FDFF",
        color: "#1E64DDFF",
        deleteIconColor: "primary.main",
        deleteIconHoverColor: "primary.dark",
      }
    : {
        backgroundColor: "transparent",
        color: "#323743FF",
        deleteIconColor: "#323743FF",
        deleteIconHoverColor: "#323743FF",
      };
  return (
    <Chip
      sx={{
        backgroundColor: color.backgroundColor,
        height: "auto",
        padding: "5px 0",
        color: color.color,
        ".MuiChip-label": {
          whiteSpace: "normal",
        },
        ".MuiChip-deleteIcon": {
          color: color.deleteIconColor,
          ":hover": {
            color: color.deleteIconHoverColor,
          },
        },
      }}
      deleteIcon={<ClearIcon />}
      {...props}
    />
  );
};

export default StyledChip;
